<mat-card class="login-card">
  <mat-card-header>
    <mat-card-title>{{ 'application.name-' + environmentName | translate }}</mat-card-title>
    <mat-card-subtitle>{{ 'login.sub-title' | translate }}</mat-card-subtitle>
  </mat-card-header>
  <mat-tab-group>
    <mat-tab label="{{ 'button.login' | translate }}">
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" style="margin: 20px 20px 0 20px;">
        <mat-card-content class="login-card-content">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'label.login' | translate }}</mat-label>
            <mat-icon matPrefix>person</mat-icon>
            <input matInput formControlName="username" type="text" autocomplete="off">
            <button type="button" mat-button matSuffix mat-icon-button aria-label="Clear">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'label.password' | translate }}</mat-label>
            <mat-icon matPrefix>lock</mat-icon>
            <input matInput [type]="hide ? 'password' : 'text'" placeholder="{{ 'label.password' | translate }}"
              formControlName="password" autocomplete="off">
            <button type=button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide">
              <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>
        </mat-card-content>
        <mat-card-actions class="login-card-action">
          <button mat-raised-button color="primary" [disabled]="isLoading">
            <mat-icon>how_to_reg</mat-icon>{{ 'button.login' | translate }}
          </button>
        </mat-card-actions>
      </form>
    </mat-tab>
    <mat-tab label="{{ 'login.forget-password' | translate }}">
      <form [formGroup]="forgetPasswordForm" (ngSubmit)="onSubmitForgetPassword()" style="margin: 20px 20px 0 20px;">
        <mat-card-content class="login-card-content">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'label.login' | translate }}</mat-label>
            <mat-icon matPrefix>person</mat-icon>
            <input matInput formControlName="username" type="text" autocomplete="off" [disabled]="isLoading">
            <button type="button" mat-button matSuffix mat-icon-button aria-label="Clear">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <!-- <mat-form-field appearance="outline">
            <mat-label>{{ 'label.company' | translate }}</mat-label>
            <mat-icon matPrefix>domain</mat-icon>
            <input matInput formControlName="societyName" type="text" autocomplete="off">
            <button type="button" mat-button matSuffix mat-icon-button aria-label="Clear">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'login.email' | translate }}</mat-label>
            <mat-icon matPrefix>alternate_email</mat-icon>
            <input matInput formControlName="societyEmail" type="text" autocomplete="off">
            <button type="button" mat-button matSuffix mat-icon-button aria-label="Clear">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field> -->
        </mat-card-content>
        <mat-card-actions class="login-card-action">
          <button mat-raised-button color="primary" [disabled]="isLoading">
            <mat-icon>send</mat-icon>{{ 'button.send' | translate }}
          </button>
        </mat-card-actions>
      </form>
    </mat-tab>
  </mat-tab-group>
</mat-card>